export default __webpack_public_path__ + "static/media/segments.cfd8f784.svg";